import { ActionTypes } from "../../constants/ActionTypes";
import { ILetterBodyImage } from "../../interfaces";

const INIT_STATE: ILetterBodyImage = {
  pageNumberSelected: 0,
  enableBrush: false,
  zoomDisabled: true,
  draw: [],
  pad: [],
  blobFile: [],
  bodyPenContent: [],
  strokes: [],
  keys: [],
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.CHANGE_LetterBodyImage: {
      let s = { ...state };
      action.payload.keys.map((item: string) => {
        s[item] = action.payload[item];
        return item;
      });

      return {
        ...s,
      };
    }

    case ActionTypes.CLEAR_LetterBodyImage: {
      return {
        ...state,
        enableBrush: false,
        draw: [],
        zoomDisabled: true,
        pageNumberSelected: 0,
        pad: [],
        blobFile: [],
        bodyPenContent: [],
        strokes: [],
      };
    }

    default:
      return state;
  }
};
